import axios from "./axios";

class HTTP {
  constructor() {
    this.axios = axios;
  }

  async httpGET(url, config = {}) {
    try {
      const response = await this.axios.get(url, config);
      return response.data;
    } catch (error) {
      console.error(`Unexpected GET error:`, error);
      if (error.response && error.response.status === 403) {
        console.error("Unexpected 403 Forbidden");
      }
      throw error;
    }
  }

  async httpPATCH(url, data, config = {}) {
    try {
      const response = await this.axios.patch(url, data, config);
      return response.data;
    } catch (error) {
      console.error(`Unexpected PATCH error:`, error);
      if (error.response && error.response.status === 403) {
        console.error("Unexpected 403 Forbidden");
      }
      throw error;
    }
  }

  async httpPOST(url, data, config = {}) {
    try {
      const response = await this.axios.post(url, data, config);
      return response.data;
    } catch (error) {
      console.error(`Unexpected POST error:`, error);
      if (error.response && error.response.status === 403) {
        console.error("Unexpected 403 Forbidden");
      }
      throw error;
    }
  }

  async httpDELETE(url, config = {}) {
    try {
      const response = await this.axios.delete(url, config);
      return response.data;
    } catch (error) {
      console.error(`Unexpected DELETE error:`, error);
      if (error.response && error.response.status === 403) {
        console.error("Unexpected 403 Forbidden");
      }
      throw error;
    }
  }

  async httpPUT(url, data, config = {}) {
    try {
      const response = await this.axios.put(url, data, config);
      return response.data;
    } catch (error) {
      console.error(`Unexpected PUT error:`, error);
      if (error.response && error.response.status === 403) {
        console.error("Unexpected 403 Forbidden");
      }
      throw error;
    }
  }
}

export default HTTP;
